module.exports = __webpack_public_path__ + "img/材料力学1_6_4.18e29590.jpg";